// src/features/residents/routes.tsx
import { Navigate, RouteObject } from "react-router-dom";
import ResidentLayout from "./layout/ResidentLayout";
import ResidentDashboard from "./screens/ResidentDashboard";
import AnnouncementsPage from "./screens/AnnouncementsPage";
import PollingPage from "./screens/PollingPage";
import IssuesPage from "./screens/IssuesPage";
import PaymentsPage from "./screens/PaymentsPage";
import ProfilePage from "./screens/ProfilePage";

export const residentRoutes: RouteObject = {
  path: "/resident",
  element: <ResidentLayout />,
  children: [
    { index: true, element: <ResidentDashboard /> },
    { path: "announcements", element: <AnnouncementsPage /> },
    { path: "polling", element: <PollingPage /> },
    { path: "issues", element: <IssuesPage /> },
    // Reporting is a sheet on the issues page now. The route stays as a
    // redirect: it was the target of the dashboard's quick action for two
    // releases and may be bookmarked, and a 404 is a worse answer than the
    // form opening where it now lives.
    { path: "issues/new", element: <Navigate to="/resident/issues?new=1" replace /> },
    { path: "payments", element: <PaymentsPage /> },
    { path: "profile", element: <ProfilePage /> },
  ],
};
